



















import { Component, Mixins, Prop } from "vue-property-decorator";

// Types
import AdminBrandId from "@/mixins/adminBrandId";

@Component
export default class AdminLeadsListView extends Mixins(AdminBrandId) {
  // Props
  @Prop({ required: false, default: () => [] })
  public routes!: any[];
  // Data
  public tableId = "LT1";
}
